import { Component, ViewEncapsulation, Input, EventEmitter, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { Subscription } from 'rxjs';

import { DatacenterType } from '../../../models/datacenter-aggrid-view';
import { UNDERSCORE } from '../../../utils/constant';
import { Document } from '../../../../commercial-documents/models/document';
import { DocumentService } from '../../../../commercial-documents/services/documents.service';
import { SafeUrlPipe } from '../../../pipes/safeurl.pipe';
import { DatePipe } from '../../../pipes/date.pipe';
import { LoadingSpinnerComponent } from '../../utils/loading-spinner.component';
import { OrderService } from '../../../../order/services/order.service';
import { DatacenterDefaultConfiguration } from '../../../datacenter/datacenter-default-configuration';
import { ScheduleBusinessOrder } from '../../../../order/models/schedule-business-order';
import { ORDER_REDIRECT_URL,
	ScheduleBusinessOrderService } from '../../../../order/services/schedule-business-order.service';
import { UserService } from '../../../services/user.service';

@Component({
	selector: 'copo-result-order-acknowledgment-card',
	templateUrl: './result-card-order-acknowledgment.component.html',
	styleUrl: './result-card-order-acknowledgment.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatIconModule,
		MatRippleModule,

		MatButtonModule,
		TranslateModule,
		RouterLink,
		NgFor,
		LoadingSpinnerComponent,
		DatePipe,
		SafeUrlPipe
	]
})
export class ResultCardOrderAcknowledgementComponent implements OnInit, OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() document?: Document;
	readonly createFilter = new EventEmitter<{ document: Document; filterType: DatacenterType }>();

	readonly UNDERSCORE = UNDERSCORE;
	scheduleBusinessOrderRequiredFields: (keyof ScheduleBusinessOrder)[] = ['supplierOrderType'];
	scheduleBusinessOrder?: Subscription;
	hasSBOrderService = false;

	constructor(
		private readonly documentService: DocumentService,
		private readonly orderService: OrderService,
		private readonly defaultConfiguration: DatacenterDefaultConfiguration,
		private readonly scheduleBusinessOrderService: ScheduleBusinessOrderService,
		private readonly userService: UserService

	) {
		const { user } = this.userService;
		this.hasSBOrderService = user.hasServiceParameterEqualsTo('PORDT', 'SBOrder', 'True');
	}

	callFilter(document: Document, filterType: DatacenterType) {
		this.createFilter.emit({ document, filterType });
	}

	downloadDocument(id: number, filename: string) {
		return this.documentService.getDownloadDocumentUrl(id, filename);
	}

	getDocumentURL(id: number, filename: string) {
		return this.documentService.getViewDocumentUrl(id, filename);
	}

	ngOnInit(): void {
		if (this.document) {
			if (this.hasSBOrderService) {
				this.scheduleBusinessOrderService.setRedirectionLink(
					this.document,
					this.scheduleBusinessOrderRequiredFields
				);
			} else {
				this.document.isSbOrder = false;
				this.document.docNavigationLink = ORDER_REDIRECT_URL;
			}
		}
	}

	async redirectToOrderDatacenter(document: Document) {
		if (document.isSbOrder) {
			await this.scheduleBusinessOrderService.sbOrderDatacenterFilter(
				document,
				this.defaultConfiguration.getDefaultView('schedule-business-order')
			);
			return;
		}
		await this.orderService.orderDatacenterFilter(
			document,
			this.defaultConfiguration.getDefaultView('order')
		);
	}

	ngOnDestroy() {
		this.scheduleBusinessOrder?.unsubscribe();
	}
}
